
import './Body.css';
import React, {useState} from "react";
import Browse from './Browse.js';
import SendNote from './SendNote.js';
import Footer from './Footer.js'

function BrowseBody() {
    const [selectedBouquet, setSelectedBouquet] = useState(null)

    return (
        <div>
            {selectedBouquet===null && 
                <Browse setSelectedBouquet={setSelectedBouquet}/>
            }
            {selectedBouquet!==null &&
                <SendNote type="prebuilt" selectedBouquet={selectedBouquet} setSelectedBouquet={setSelectedBouquet}/>
            }
            <Footer />
        </div>
    )
}

export default BrowseBody;